import { lazy } from 'react';
import Loadable from 'components/Loadable';

const EmployeeList = Loadable(lazy(() => import('./components/employee-list/EmployeeList')));
const EmployeeForm = Loadable(lazy(() => import('./components/employee-form/EmployeeForm')));

export const employeeRoutes = {
  path: 'employees',
  children: [
    { index: true, element: <EmployeeList /> },
    { path: 'employee', element: <EmployeeList /> },
    { path: 'add', element: <EmployeeForm /> },
    { path: ':id', element: <EmployeeForm /> }
  ]
};

export default employeeRoutes;
